import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Page } from "@/components/common/page";
import { SettingsTabs } from "@/components/settings/settings-tabs";

export const Route = createFileRoute("/p/$project/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  const { project } = Route.useParams();
  return (
    <Page>
      <SettingsTabs project={project} />
      <Outlet />
    </Page>
  );
}
